import { AbstractControl } from '@angular/forms';
export class PasswordValidation {

    static MatchPassword(AC: AbstractControl) {
        let password = AC.get('custPass').value; // to get value in input tag
        let confirmPassword = AC.get('custPass2').value; // to get value in input tag
        if (password != confirmPassword) {
            //console.log('false');
            AC.get('custPass2').setErrors({ MatchPassword: true })
        } else {
            //console.log('true');
            return null
        }
    }
}